import {normalize} from 'normalizr';
import * as schema from './schemas';
import {actions} from '../actions';
import {
  copyContext,
  flattenKeys,
  expandKeys,
} from '../../../../utilities/parse';

const initialState = {};

export default function stepsReducer(state = initialState, action) {
  switch (action.type) {
    case actions.STEPS.FETCH_FULFILLED: {
      const {step} = action.payload;
      const {
        entities: {steps},
      } = normalize(step, schema.Step);
      const normalizedStep = steps[step.handle];

      return {
        ...state,
        [step.handle]: {
          ...normalizedStep,
          questionDeps: expandKeys(normalizedStep.questions),
        },
      };
    }

    case actions.STEPS.REPLACE_DYNAMIC_QUESTIONS: {
      const {stepHandle, questionHandle, newQuestionHandles} = action.payload;
      const step = state[stepHandle];

      if (!step.questions.includes(questionHandle)) {
        return state;
      }

      const questionDeps = copyContext(
        step.questionDeps,
        newQuestionHandles,
        questionHandle
      );
      return {
        ...state,
        [stepHandle]: {
          ...step,
          questions: flattenKeys(questionDeps),
          questionDeps,
        },
      };
    }

    case actions.PROGRESS.RESET_SERVICE_SELECTION: {
      return {};
    }
  }

  return state;
}
